import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { ParentComponent } from './parent.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AuthenticationComponent } from './authentication/authentication.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';
import { AuthService } from './authentication/auth.service';
import { NavbarComponent } from './dashboard/navbar/navbar.component';
import { SidebarComponent } from './dashboard/sidebar/sidebar.component';
import { NavbarService } from './dashboard/navbar.service';
import { StudentProfileComponent } from './dashboard/pages/student-details/student-profile/student-profile.component';
import { DigitalReportCardComponent } from './dashboard/pages/digital-report-card/digital-report-card.component';
import { HistoricalDataSummaryComponent } from './dashboard/pages/historical-data/summary.component';
//import { SemesterSummaryComponent } from '../components/dataAnalytics/Digital-report-card/digital-report-card.component';
import { MarketPlaceComponent } from './dashboard/pages/market-place/market-place.component';
import { ParentHomeComponent } from './dashboard/pages/parent-home/parent-home.component';
import { ParentDataService } from './service/parent-data.service';
import { HttpClientModule } from '@angular/common/http';
import { StudentDataService } from './service/student-data.service';
import { ChartsModule } from 'ng2-charts/ng2-charts';
import { ParentChildService } from '../components/parentchild/parentchild.service';
//import { ConfirmationService, Paginator } from 'primeng/primeng';
import {DialogModule, PaginatorModule} from 'primeng/primeng';



/////////////////
import { SelectdashboardHComponent } from './dashboard/pages/course/Selectdashboard/selectdashboardH';
import { SelectdashboardstudentHComponent } from './dashboard/pages/course/Selectdashboardstudent/selectdashboardstudentH';
import { SelectdashboardteacherHComponent } from './dashboard/pages/course/Selectdashboardteacher/selectdashboardteacherH';

import { AddsemHComponent } from './dashboard/pages/course/semester/semesterH.component';
import { AddsemsubjectHComponent } from './dashboard/pages/course/subject/semsubjectH.component';
import { AddsubmoduleHComponent } from './dashboard/pages/course/submodule/submoduleH.component';
import { AddTeachersubjectHComponent } from './dashboard/pages/course/teachersubject/teachersubjectH.component';
import { ViewcourseHComponent } from './dashboard/pages/course/viewcourse/viewcourseH.component';
import { AddAcademicyearHComponent } from './dashboard/pages/course/AddAcademicyear/addAcademicyearH.component';
import { AddLevelAddSchoolHComponent } from './dashboard/pages/course/LevelAddSchool/AddLevelAddSchoolH';
import { AddgradetolevelHComponent } from './dashboard/pages/course/AddGradeToLevel/addgradetolevelH.component';
import { AddExamsHComponent } from './dashboard/pages/course/AddExams/AddExamsH';
import { AddSemesterSComponent } from './dashboard/pages/course/AddSemesters/addSemesterS.component';
import { AddSubjectsSComponent } from './dashboard/pages/course/AddsubjectS/addSubjectsS.component';
import { SubSubjectsSComponent } from './dashboard/pages/course/SubSubjectsS/subSubjectsS.component';
import { AddTeachersubjectSComponent } from './dashboard/pages/course/teachersubjectschool/teachersubjectS.component';
import { AddBatchersHComponent } from './dashboard/pages/course/batchers/batchersH.component';

import { StudentveiwHQComponent } from './dashboard/pages/parentchild/viewhigherend/StudentveiwHQ.component';
import { AddstudentregQComponent } from './dashboard/pages/parentchild/studentreg/studentregQ.component';
import { SubParentChildQComponent } from './dashboard/pages/parentchild/viewschool/parentchildQ.component';
import { SubParentChildAdvacnedQComponent } from './dashboard/pages/parentchild/viewschool/parentchild_advancedQ.component';
import { DigitalReportCardQComponent2 } from './dashboard/pages/course/Digital-report-card2Q/digital-report-card2Q.component';
import { RegistrationSQComponent } from './dashboard/pages/parentchild/studentregSQ/registrationSQ.component';
import { PromotionsSQComponent } from './dashboard/pages/parentchild/promotionsSQ/promotionsSQ.component';

import { SharedModule } from '../shared/shared.module';
import { DataTablesModule } from 'angular-datatables';
import { PrimeNgModule } from '../shared/primeng/primengmodule';

import { AddTSubjectQuantaComponent } from './dashboard/pages/course/Teachers/addsubject.component';
import { AddTeacherQuantaComponent } from './dashboard/pages/course/Teachers/addTeacher.component';
import { TeachersViewQuantaComponent } from './dashboard/pages/course/Teachers/teachers.component';
import { DigitalReportCardBulkUploadQuantaComponent } from './dashboard/pages/course/digital-report-card-bulk-upload-q/digital-report-card-bulk-upload.component';
import { DigitalReportCardBulkUploadSComponent } from './dashboard/pages/course/digital-report-card-bulk-upload-s/digital-report-card-bulk-upload.component';
import {StudentListViewComponent} from './dashboard/pages/student-details/student-list-view/student-list-view.component';
import {StudentPromotionComponent} from './dashboard/pages/student-details/student-promotion/student-promotion.component';
import {StudentRegistrationComponent} from './dashboard/pages/student-details/student-registration/student-registration.component';
import {StudentBulkUploadComponent} from './dashboard/pages/student-details/student-bulk-upload/student-bulk-upload.component';
import {ManageUserDepartmentComponent} from './dashboard/pages/manage-user/manage-user-department/manage-user-department.component';
import {DepartmentService} from '../components/manageuser/department/department.service';
import {ManageUserComponent} from './dashboard/pages/manage-user/manage-user/manage-user.component';
import {UserService} from '../components/manageuser/user/user.service';
import {SectionService} from '../components/manageuser/sections/sections.service';
import {ManageAddUserComponent} from './dashboard/pages/manage-user/manage-add-user/manage-add-user.component';
import {AddUserService} from '../components/manageuser/adduser/adduser.service';
import {ManageUserGroupsComponent} from './dashboard/pages/manage-user/manage-user-groups/manage-user-groups.component';
import {TeacherViewComponent} from './dashboard/pages/teacher-details/teacher-view/teacher-view.component';
import {AddTeacherComponent} from './dashboard/pages/teacher-details/add-teacher/add-teacher.component';
import {SubjectAssignComponent} from './dashboard/pages/teacher-details/subject-assign/subject-assign.component';
import {UploadPapersComponent} from './dashboard/pages/quonta-intelligence/upload-papers/upload-papers.component';
import {QuestionBankComponent} from './dashboard/pages/quonta-intelligence/question-bank/question-bank.component';
import {QuestionsGeneratorComponent} from './dashboard/pages/quonta-intelligence/questions-generator/questions-generator.component';
import {ManageDRCSettingsComponent} from './dashboard/pages/course/ManageDRCSettings/ManageDRCSettings.component';
import {ViewPaperComponent} from './dashboard/pages/quonta-intelligence/view-paper/view-paper.component';
import {Ng2SearchPipeModule} from 'ng2-search-filter';
import {ParentDRCAccessComponent} from './dashboard/pages/course/ParentDRCAccess/ParentDRCAccess.component';
import {QuestionsFilterComponent} from './dashboard/pages/quonta-intelligence/questions-filter/questions-filter.component';
import {GeneratedPapersComponent} from './dashboard/pages/quonta-intelligence/generated-papers/generated-papers.component';
import {ViewGeneratedPaperComponent} from './dashboard/pages/quonta-intelligence/view-generated-paper/view-generated-paper.component';
import {FreezeDRCGradesComponent} from './dashboard/pages/course/FreezeDRCGrades/FreezeDRCGrades.component';
import {SyllabusBankComponent} from './dashboard/pages/quonta-intelligence/syllabus-bank/syllabus-bank.component';
import {UploadSyllabusComponent} from './dashboard/pages/quonta-intelligence/upload-syllabus/upload-syllabus.component';
import {ViewSyllabusComponent} from './dashboard/pages/quonta-intelligence/view-syllabus/view-syllabus.component';
import { MyNotesComponent } from './dashboard/pages/quonta-intelligence/my-notes/my-notes.component';
import { Daterangepicker } from 'ng2-daterangepicker';
import {PromptsComponent} from './dashboard/pages/quonta-intelligence/prompts/prompts.component';
import {TranslatePapersComponent} from './dashboard/pages/quonta-intelligence/translate-papers/translate-papers.component';
import {ModifyPapersComponent} from './dashboard/pages/quonta-intelligence/modify-papers/modify-papers.component';

@NgModule({
  declarations: [
    ParentComponent,
    DashboardComponent,
    NavbarComponent,
    SidebarComponent,
    StudentProfileComponent,
    StudentListViewComponent,
    StudentPromotionComponent,
    StudentRegistrationComponent,
    UploadPapersComponent,
    ModifyPapersComponent,
    TranslatePapersComponent,
    UploadSyllabusComponent,
    StudentBulkUploadComponent,
    QuestionBankComponent,
    GeneratedPapersComponent,
    SyllabusBankComponent,
    QuestionsGeneratorComponent,
    MyNotesComponent,
    QuestionsFilterComponent,
    ManageUserDepartmentComponent,
    ManageUserComponent,
    ManageAddUserComponent,
    ManageUserGroupsComponent,
    TeacherViewComponent,
    AddTeacherComponent,
    SubjectAssignComponent,
    DigitalReportCardComponent,
    HistoricalDataSummaryComponent,
    MarketPlaceComponent,
    ParentHomeComponent,
    ///////////////////////
    SelectdashboardHComponent,
    SelectdashboardstudentHComponent,
    SelectdashboardteacherHComponent,

    AddTSubjectQuantaComponent,
    AddTeacherQuantaComponent,
    TeachersViewQuantaComponent,

    AddAcademicyearHComponent,
    AddsemHComponent,
    AddLevelAddSchoolHComponent,
    AddgradetolevelHComponent,

    AddsemsubjectHComponent,
    AddsubmoduleHComponent,
    AddTeachersubjectHComponent,
    ViewcourseHComponent,

    AddExamsHComponent,
    AddSemesterSComponent,
    AddSubjectsSComponent,
    SubSubjectsSComponent,
    AddTeachersubjectSComponent,
    AddBatchersHComponent,
    ManageDRCSettingsComponent,
    FreezeDRCGradesComponent,
    ParentDRCAccessComponent,
    ViewPaperComponent,
    PromptsComponent,
    ViewSyllabusComponent,
    ViewGeneratedPaperComponent,

    RegistrationSQComponent,
    PromotionsSQComponent,


    StudentveiwHQComponent,
    AddstudentregQComponent,
    SubParentChildQComponent,
    SubParentChildAdvacnedQComponent,
    DigitalReportCardQComponent2,
    DigitalReportCardBulkUploadQuantaComponent,
    DigitalReportCardBulkUploadSComponent


  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    ReactiveFormsModule,
    RouterModule,
    HttpClientModule,
    ChartsModule,
    DialogModule,

    SharedModule,
    DataTablesModule,
    PrimeNgModule,
    PaginatorModule,
    Ng2SearchPipeModule,
    Daterangepicker
  ],
  providers: [AuthService,
    NavbarService,
    ParentDataService,
    StudentDataService,
    ParentChildService,
    DepartmentService,
    UserService,
    AddUserService,
    SectionService],
  bootstrap: [ParentComponent]
})
export class ParentModule { }



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/parent.module.ts